import styled from '@emotion/styled';

export const Card = styled.section`
  max-width: 21rem;
`;
